import { SnowplowService } from 'wanderu-service-analytics';

function hamburgerClicked() {
    SnowplowService.fireStructuredEvent({
        category: 'navigation',
        action: 'expand_menu',
        label: 'hamburger_icon',
        property: {
            nav_type: 'hamburger',
        },
    });
}

export default {
    hamburgerClicked,
};
